import React from "react";
import { Field, Input } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import SearchResourceInGraph from "../../GenericComponent/SearchResourceInGraph";
import ScopeSelectorContainer from "../../../Containers/GenericContainer/ScopeSelectorContainer";
import "../../CSS/IaAgent.css";

export default function IdentityTab({ agentData, updateField, isCreateMode }) {
  const { t } = useTranslation();
  const personality = agentData.agentPersonality || {};

  return (
    <div className="ia-agent-tab">
      {isCreateMode && !agentData.id && (
        <>
          <Field label={t("RESOURCE")} className="field-style" required>
            <div className="div-container-search">
              <SearchResourceInGraph
                displayName={agentData.displayName}
                disabled={false}
                onSelectUser={(resource) => {
                  if (resource?.id && resource?.displayName) {
                    updateField("id", resource.id);
                    updateField("displayName", resource.displayName);
                    if (!agentData.agentPersonality?.name) {
                      updateField("agentPersonality.name", resource.displayName);
                    }
                  }
                }}
              />
            </div>
          </Field>
          <Field label={t("SCOPE")} className="field-style">
            <ScopeSelectorContainer
              value={agentData.scope || "default"}
              onSelect={(scope) => updateField("scope", scope || "default")}
            />
          </Field>
        </>
      )}

      {agentData.id && (
        <>
          <Field label={t("RESOURCE_ACCOUNT_ID")} className="field-style">
            <Input value={agentData.id} disabled />
          </Field>
          <Field label={t("RESOURCE_ACCOUNT_NAME")} className="field-style">
            <Input value={agentData.displayName || ""} disabled />
          </Field>

          <Field label={t("IA_AGENT_NAME")} className="field-style" required>
            <Input
              value={personality.name || ""}
              onChange={(_, d) => updateField("agentPersonality.name", d.value)}
              placeholder={t("IA_AGENT_NAME_PLACEHOLDER")}
            />
          </Field>

          <Field label={t("IA_AGENT_ROLE")} className="field-style">
            <Input
              value={personality.role || ""}
              onChange={(_, d) => updateField("agentPersonality.role", d.value)}
              placeholder={t("IA_AGENT_ROLE_PLACEHOLDER")}
            />
          </Field>

          <Field label={t("IA_AGENT_COMPANY")} className="field-style">
            <Input
              value={personality.company || ""}
              onChange={(_, d) => updateField("agentPersonality.company", d.value)}
              placeholder={t("IA_AGENT_COMPANY_PLACEHOLDER")}
            />
          </Field>
        </>
      )}
    </div>
  );
}
